interface Props {
  title: string;
  message: string;
  action?: { label: string; onClick(): void };
}

export function Blocker({ title, message, action }: Props) {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        style={{
          maxWidth: 440,
          background: '#fff',
          borderRadius: 12,
          padding: 32,
          boxShadow: '0 8px 32px rgba(15,23,42,0.12)',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
        <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10, color: '#0f172a' }}>{title}</h1>
        <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.55 }}>{message}</p>
        {action && (
          <button
            onClick={action.onClick}
            style={{
              marginTop: 18,
              padding: '9px 18px',
              background: '#2563eb',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
